import { Button, message } from 'antd';
import { useState, useRef, useLayoutEffect } from 'react';
import { useTranslate } from '@tolgee/react';
import { toPng } from 'html-to-image';
import TradeComponentDetail from './TradeComponentDetail';
import download from 'utils/download';
import { useOrgValue } from 'hooks/business/system/useOrg';
import type { OrgValue } from 'hooks/business/system/useOrg';
import { useLatest } from 'ahooks';

const useLuckywayFeature = () => {
  const orgValue = useOrgValue();
  return isLuckyway(orgValue);
};

const isLuckyway = (orgValue?: OrgValue) => {
  if (import.meta.env.VITE_ENV === 'staging' || import.meta.env.VITE_ENV === 'feature') {
    return orgValue?.orgId === 1163;
  }
  return orgValue?.orgId === 10342 || orgValue?.orgId === 33724 || orgValue?.orgId === 1002;
};

// luckyway的定制需求
export const ExportOrderButton = (props: {
  trade: Conversation.Trade.TradeWithLogistics;
  conversation: Conversation.Conversation;
}) => {
  const { t } = useTranslate();
  const isLuckyway = useLuckywayFeature();
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { trade, conversation } = props;
  const tradeRef = useLatest(trade);

  useLayoutEffect(() => {
    if (ref.current) {
      const container = ref.current.querySelector('#trade-container');
      setTimeout(async () => {
        try {
          const dataUrl = await toPng(container as HTMLElement, { pixelRatio: 1 });
          await download(dataUrl, `${tradeRef.current.externalTradeId}.png`, true);
          message.success(t('export_modal_downloaded'));
          setVisible(false);
        } catch (_) {
          message.error(t('ViewShops.导出失败'));
          setVisible(false);
        }
      }, 1500);
    }
  }, [visible, tradeRef, t]);

  return isLuckyway ? (
    <>
      {visible && (
        <div id="fuck" ref={ref} style={{ height: '0px', overflow: 'hidden' }}>
          <TradeComponentDetail
            exportMode
            trade={trade}
            conversation={conversation}
            width={504}
            onUpdate={() => {}}
            onDetailClose={() => {}}
          />
        </div>
      )}
      <Button size="small" loading={visible} onClick={() => setVisible(true)}>
        {t('review.导出')}
      </Button>
    </>
  ) : null;
};
